import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ISignature } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class SignatureService extends BaseService<ISignature> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'signature');
  }
}

export { ISignature } from '../shared/api';
